export const isDescendant = (parent: Node, child: Node | null): boolean => {
  let node = child;
  while (node) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};
